<template>
    <Head :title="pageTitle"/>
    <Navbar/>
    <div class="section">
        <slot class="head" name="head"></slot>
        <div class="pt-5 container">
            <slot name="main"></slot>
        </div>
        <ScrollTop/>
    </div>
    <Footer v-if="showFooter"/>
    <Toast :breakpoints="{'920px': {width: '100%', right: '0', left: '0'}}" position="bottom-right"/>
</template>

<script>
import {Head} from "@inertiajs/vue3";
import Footer from "./Partials/Footer.vue";
import Navbar from "./Partials/Navbar.vue";
import ScrollTop from 'primevue/scrolltop';
import Toast from 'primevue/toast';

import PathWidget from "@/Components/NewsPortal/PathWidget.vue";
import AdComponent from '@/Components/AdComponent.vue';

export default {
    components : {
        AdComponent,
        Head,
        Footer,
        Navbar,
        PathWidget,
        ScrollTop,
        Toast,
    },
    props      : {
        title      : String,
        showFooter : {
            default : true,
            type    : Boolean,
        }
    },
    computed   : {
        pageTitle() {
            if (this.title) return this.getPageTitle(this.title);

            return 'CyprusNews.Live: Όλες οι τελευταίες ειδήσεις της Κύπρου'
        },
    },
    updated() {
        if (this.$page.props.message && localStorage.getItem('message_fingerprint') !== this.$page.props.message.fingerprint) {
            this.$toast.add({severity : this.$page.props.message.type, detail : this.$page.props.message.message, life : 3000});
            localStorage.setItem('message_fingerprint', this.$page.props.message.fingerprint)
        }
    },
    methods : {
        getPageTitle(title) {
            return `${title} | CyprusNews.Live`
        }
    },
    mounted() {
//        const script = document.createElement('script');
//        script.setAttribute('src', 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2609724905403481');
//        script.setAttribute('crossorigin', 'anonymous');
//        script.setAttribute('defer', '');
//        document.head.appendChild(script);

//        const script2 = document.createElement('script');
//        script2.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-D48WVM05V8');
//        script2.setAttribute('defer', '');
//        document.head.appendChild(script2);
    }

};
</script>
